<template>
  <div>
    <page-header :title="$t('scope.text_292')" />
    <page-body>
      <bill-manager-list :id="listId" :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
import BillManagerList from './components/List'

export default {
  name: 'BillManagerIndex',
  components: {
    BillManagerList,
  },
  data () {
    return {
      listId: 'bill-manager-list',
      getParams: {
        details: true,
      },
    }
  },
}
</script>
